import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEdit, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons'

library.add(faEdit, faTrashAlt, faPlus)

export default FontAwesomeIcon
